import React from "react";
import T from "prop-types";
import api from "APP_ROOT/api";
import { DropDownItem, ConfirmAction, Icon } from "MODULES/shared/components";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import {
  translateProps,
  toggleSwitch,
  renderIf
} from "MODULES/shared/decorators";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { GONE, EXCHANGE_GONE_OUTRIGHT } from "MODULES/inventories/constants";
import { ACCOUNTING, ADMIN } from "MODULES/users/constants";
import { toastr } from "react-redux-toastr";

export function CancelOutrightSale({ cancel, cancelling, open, close }) {
  return (
    <DropDownItem onClick={open}>
      <Icon name="ban" fixed />
      <span className="with-padding">Cancel Outright Sale</span>
      <ConfirmAction onConfirm={cancel} close={close} open={cancelling}>
        <strong>Heads up! </strong>
        <span className="with-padding">
          Are you sure you want to cancel this outright sale?
        </span>
      </ConfirmAction>
    </DropDownItem>
  );
}

CancelOutrightSale.propTypes = {
  cancel: T.func.isRequired,
  cancelling: T.bool.isRequired,
  open: T.bool.isRequired,
  close: T.func.isRequired
};

const withOutrightCancellation = translateProps(
  ({
    lineItem: {
      id: itemId,
      sales_order_id: salesOrderId,
      commission_paid: commissionPaid
    },
    close,
    expireLineItems,
    refresh
  }) => ({
    cancel: () => {
      if (commissionPaid) {
        return toastr.error(
          "Commission Paid",
          "Commission for Outright Sale is paid. Sale cannot be cancelled."
        );
      }
      return api.salesOrders.lineItems.cancelOutrightSale(itemId).then(() => {
        refresh(salesOrderId).then(() => {
          expireLineItems();
          close();
        });
      });
    }
  })
);

const meetsCancellationCriteria = renderIf(
  ({
    lineItem: {
      cancelled,
      created_by_id: createdById,
      outright_sale: outrightSale,
      inventory: { repair_status: repairStatus, status }
    },
    currentUser: { role, id: userId }
  }) =>
    ([ADMIN, ACCOUNTING].includes(role) || createdById === userId) &&
    !cancelled &&
    (status === GONE || repairStatus === EXCHANGE_GONE_OUTRIGHT) &&
    outrightSale
);

export default withSalesOrder(
  toggleSwitch("cancelling")(
    withCurrentUser(
      withOutrightCancellation(meetsCancellationCriteria(CancelOutrightSale))
    )
  )
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/CancelOutrightSale/CancelOutrightSale.jsx